export default "__VITE_ASSET__CbmOHtPH__"